import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';

export default function About() {
  const pageTitle = '关于我们 - 桃桃漫画网 - 韩国漫画在线阅读平台';
  const pageDesc = '桃桃漫画网致力于为漫画爱好者提供海量免费韩国漫画资源。了解我们的品牌故事、荣誉资质和商务合作信息。';

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桃桃漫画网',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '韩国漫画在线阅读平台，提供海量免费韩国漫画资源',
    foundingDate: '2022',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@lcwb.cn',
      availableLanguage: ['Chinese'],
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: typeof window !== 'undefined' ? window.location.origin + '/' : '',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
      },
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '桃桃漫画网是一个什么样的平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '桃桃漫画网是专注于韩国漫画的在线阅读平台，为广大漫画爱好者提供海量免费漫画资源。平台涵盖浪漫爱情、奇幻冒险、都市生活、悬疑推理、动作热血、搞笑日常、恐怖灵异、历史古风等多种分类，满足不同读者的阅读需求。',
        },
      },
      {
        '@type': 'Question',
        name: '桃桃漫画网的漫画资源是否正版？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '桃桃漫画网与多家韩国漫画版权方保持合作关系，努力为读者提供正版优质的漫画内容。我们尊重知识产权，致力于构建健康、可持续的漫画阅读生态。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与桃桃漫画网进行商务合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '欢迎通过商务合作邮箱 hello@lcwb.cn 与我们取得联系。我们开放多种合作模式，包括内容授权、广告投放、联合推广等。我们的商务团队将在收到邮件后1-3个工作日内回复。',
        },
      },
      {
        '@type': 'Question',
        name: '桃桃漫画网是否支持移动端阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，桃桃漫画网全面适配手机、平板和电脑等多种设备。无论您使用什么设备访问，都能获得流畅、舒适的阅读体验，无需下载额外应用。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords="桃桃漫画网,关于我们,韩国漫画,画免费,品牌介绍,商务合作,在线阅读平台"
        canonicalUrl="/about"
        ogType="website"
        schemaData={[orgSchema, breadcrumbSchema, faqSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

          {/* Brand Introduction */}
          <section className="flex flex-col lg:flex-row gap-8 px-4 md:px-6 py-14 md:py-20">
            <div className="lg:w-1/3 flex flex-col items-start gap-4">
              <span className="inline-block px-4 py-1.5 border border-secondary-300 text-secondary-700 text-sm rounded-full">
                关于我们
              </span>
              <div className="w-full max-w-[400px] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20workspace%20with%20Korean%20manhwa%20artwork%20on%20walls%2C%20warm%20natural%20lighting%2C%20wooden%20desk%20with%20drawing%20tablet%2C%20bookshelves%20filled%20with%20comics%2C%20cozy%20atmosphere%2C%20minimalist%20interior%20design%2C%20clean%20aesthetic%2C%20professional%20creative%20environment&width=800&height=1000&seq=about-brand-taotao&orientation=portrait"
                  alt="桃桃漫画网品牌介绍"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="lg:w-2/3 flex flex-col justify-center">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight mb-4 font-heading">
                以漫画之名
                <br />
                连接每一颗热爱
                <br />
                故事的心
              </h1>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-xl">
                桃桃漫画网成立于2022年，致力于为广大漫画爱好者打造一个高品质、免费的韩国漫画在线阅读平台。我们相信，好的故事应该被更多人看到，优秀的漫画作品值得被广泛传播。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-xl">
                平台目前收录超过800部韩国漫画作品，涵盖8大分类，每日更新最新章节。我们的团队由漫画爱好者和技术专家组成，持续优化阅读体验，让每一位读者都能沉浸在精彩的漫画世界中。
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 px-7 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                联系我们
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </section>

          {/* Platform Data */}
          <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <div className="mb-10">
                <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  TAOTAO COMICS
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mt-1 font-heading">
                  平台数据
                </h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <div className="bg-foreground-900 rounded-lg p-6 md:p-8 text-background-50">
                  <div className="text-4xl md:text-5xl font-bold mb-2">800+</div>
                  <p className="text-sm text-foreground-300">收录漫画作品</p>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed">涵盖八大分类，持续更新中</p>
                </div>

                <div className="bg-background-50 rounded-lg overflow-hidden">
                  <div className="relative">
                    <img
                      src="https://readdy.ai/api/search-image?query=Korean%20comic%20exhibition%20award%20ceremony%2C%20trophy%20on%20display%2C%20professional%20event%20photography%2C%20warm%20lighting%2C%20elegant%20setting%2C%20shallow%20depth%20of%20field%2C%20clean%20background%2C%20prestigious%20atmosphere&width=800&height=600&seq=about-honor-taotao&orientation=landscape"
                      alt="荣誉资质"
                      className="w-full h-48 object-cover object-top"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center gap-1 bg-background-50/80 text-foreground-800 text-xs px-2.5 py-1 rounded-full">
                        <i className="ri-award-fill w-3.5 h-3.5 flex items-center justify-center text-primary-500"></i>
                        荣誉资质
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="font-semibold text-foreground-900 mb-2">行业认可</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">荣获2025年度最佳漫画阅读平台，2024年度用户最喜爱漫画APP等多项行业荣誉。</p>
                  </div>
                </div>

                <div className="bg-background-50 rounded-lg overflow-hidden">
                  <div className="p-5">
                    <h3 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-2">用户信赖</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed mb-4">
                      日均活跃用户超过50万，用户平均阅读时长45分钟，口碑推荐率达92%。我们用心做好每一个细节，赢得用户的信赖与喜爱。
                    </p>
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20office%20team%20collaboration%2C%20diverse%20creative%20professionals%20working%20together%2C%20warm%20natural%20light%2C%20casual%20professional%20atmosphere%2C%20clean%20minimalist%20workspace%2C%20genuine%20teamwork%20moment%2C%20editorial%20photography&width=600&height=400&seq=about-trust-taotao&orientation=landscape"
                      alt="媒体报道"
                      className="w-full rounded-lg object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Business Cooperation */}
          <section id="contact" className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-[800px] mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                  商务合作
                </h2>
                <p className="text-sm text-foreground-600 mt-2">我们开放多种合作模式，期待与您携手共赢</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-12">
                {[
                  {
                    icon: 'ri-file-copy-line',
                    title: '内容授权合作',
                    desc: '欢迎漫画版权方与我们联系，共同推广优质漫画内容，触达更广泛的读者群体。',
                  },
                  {
                    icon: 'ri-advertisement-line',
                    title: '广告投放合作',
                    desc: '提供精准的广告投放方案，帮助品牌高效触达漫画爱好者核心用户群。',
                  },
                  {
                    icon: 'ri-group-line',
                    title: '联合推广合作',
                    desc: '跨界联动，通过漫画IP与品牌深度结合，打造创新的营销传播方式。',
                  },
                  {
                    icon: 'ri-lightbulb-line',
                    title: '其他合作咨询',
                    desc: '如果您有其他合作想法，欢迎随时联系我们，我们乐于探索各种合作可能。',
                  },
                ].map((item, i) => (
                  <div key={i} className="bg-background-100 rounded-lg p-5">
                    <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                      <i className={`${item.icon} text-accent-700 text-lg w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <h3 className="text-lg font-bold text-foreground-900 mb-4 font-heading">联系方式</h3>
                <div className="space-y-3 text-sm text-foreground-700">
                  <div className="flex items-center gap-3">
                    <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
                    <span>商务合作邮箱：hello@lcwb.cn</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
                    <span>版权合作邮箱：hello@lcwb.cn</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-customer-service-2-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
                    <span>客服邮箱：hello@lcwb.cn</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}